module.exports = __webpack_public_path__ + "img/guardian.e9cb41fe.svg";